// Reusable password input with eye-toggle to show/hide the password.
// Drop-in replacement for <input type="password" /> using the same `input-classic` styling.
import { useState } from "react";
import { Eye, EyeOff } from "lucide-react";

export default function PasswordInput({
  value,
  onChange,
  required = false,
  minLength,
  placeholder,
  className = "",
  autoComplete = "current-password",
  testId,
  disabled = false,
  name,
}) {
  const [visible, setVisible] = useState(false);
  return (
    <div className="relative">
      <input
        data-testid={testId}
        type={visible ? "text" : "password"}
        value={value}
        onChange={onChange}
        required={required}
        minLength={minLength}
        placeholder={placeholder}
        autoComplete={autoComplete}
        disabled={disabled}
        name={name}
        className={`input-classic pr-10 ${className}`}
        style={{ width: "100%" }}
      />
      <button
        type="button"
        data-testid={testId ? `${testId}-toggle` : "password-toggle"}
        onClick={() => setVisible((v) => !v)}
        aria-label={visible ? "Masquer le mot de passe" : "Afficher le mot de passe"}
        tabIndex={-1}
        className="absolute right-2 top-1/2 -translate-y-1/2 p-1.5 transition-colors"
        style={{ color: "var(--muted)", background: "transparent" }}
      >
        {visible ? <EyeOff size={16} /> : <Eye size={16} />}
      </button>
    </div>
  );
}
